import { gql, TypedDocumentNode } from "@apollo/client";
import type { BackgroundCheckOrder } from "./types";

export type PersonBackgroundCheckOrderQueryData = {
  person: {
    id: string;
    firstName?: string | null;
    backgroundCheckOrders: BackgroundCheckOrder[];
  };
};

export type PersonBackgroundCheckOrderQueryVariables = {
  personId: string;
};

export const GET_PERSON_BACKGROUND_CHECK_ORDER_QUERY: TypedDocumentNode<
  PersonBackgroundCheckOrderQueryData,
  PersonBackgroundCheckOrderQueryVariables
> = gql`
  query GetPersonBackgroundCheckOrder($personId: ID!) {
    person(id: $personId) {
      id
      firstName
      backgroundCheckOrders {
        id
        status
        paidAt
        providerId
        awaitingModeration
        staffInvitationCreatable
        staffInvitationEmailable
        createdAt
        updatedAt
        updates {
          id
          status
          result
          percentComplete
          createdAt
          updatedAt
        }
      }
    }
  }
`;
